import { CLAIM_TYPE_ALL_OP } from './getTreeOptions';

export const extractClaimTypesAndBenefits = (values: string[]) => {
  const excludeAllOptionValues = values.filter((value) => !value.startsWith(CLAIM_TYPE_ALL_OP));
  const keys = excludeAllOptionValues.map((v) => {
    let _claimTypeKey = '';
    let _benefitCodeKey = '';
    if (v.includes('__')) {
      const [claimType, benefitCode] = v.split('__');
      _claimTypeKey = claimType;
      _benefitCodeKey = benefitCode;
    } else {
      _claimTypeKey = v;
    }

    return {
      claimTypeKey: _claimTypeKey,
      benefitCodeKey: _benefitCodeKey,
    };
  });

  const claimTypes: string[] = [];
  const benefitCodes: string[] = [];
  keys.forEach((k) => {
    if (k.claimTypeKey) claimTypes.push(k.claimTypeKey);
    if (k.benefitCodeKey) benefitCodes.push(k.benefitCodeKey);
  });

  return { claimTypes, benefitCodes };
};
